import React from 'react'
import classNames from 'classnames'
import { useDroppable } from '@dnd-kit/core'
import { Draggable } from './draggable'

export const Droppable = ({
    droppableId,
    index,
    correctWord,
    selectedWordPair,
    isDragging,
    draggingId,
    disabled,
    wordHeight,
}) => {
    const wordIsCorrect = selectedWordPair && selectedWordPair.word === correctWord
    const {setNodeRef} = useDroppable({
        id: droppableId,
        disabled: disabled || wordIsCorrect,
    })

    const dropAreaClasses = classNames(`relative flex flex-column justify-center items-stretch border border-dashed text-sm font-medium h-[54px] rounded-b-md`, {
        // 'border-alertGreen': isDragging && !wordIsCorrect,
        'border-transparent': wordIsCorrect || (selectedWordPair && !isDragging),
        'border-mediumGrey': !selectedWordPair,
    })

    return (
        <div
            ref={setNodeRef}
            className={dropAreaClasses}
            style={{height: `${wordHeight}px`}}
        >
            { selectedWordPair && (
                <Draggable
                    index={index}
                    withMargin={false}
                    fromDroppableId={droppableId}
                    draggingId={draggingId}
                    wordIsCorrect={wordIsCorrect}
                    redBorder={!wordIsCorrect}
                >
                    {selectedWordPair.word}
                </Draggable>
            )}
        </div>
    )
}
